import React from 'react'
import { defineMessage, useIntl } from 'react-intl'

const singleDashMessage = defineMessage({
  id: 'VkLLMy0yH2',
  defaultMessage: '-',
  description: 'Single dash used as a not-available placeholder in data tables',
})

const doubleDashMessage = defineMessage({
  id: 'VOsGevd/5S',
  defaultMessage: '--',
  description: 'Double dash used as a not-available placeholder in data tables',
})

const messages = {
  single: singleDashMessage,
  double: doubleDashMessage,
} as const

interface Props {
  variant?: 'single' | 'double'
}

function NotAvailablePlaceholder({ variant = 'double' }: Props) {
  const intl = useIntl()
  return <>{intl.formatMessage(messages[variant])}</>
}

export default NotAvailablePlaceholder
